import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 14px;
  height: 14px;
`

// TODO Remove the onClick!
const Cancel = ({ title = 'Cancel', onClick, ...rest }: IconProps & { onClick?: () => void }) => (
  <StyledIcon onClick={onClick} viewBox="0 0 16 16" title={title} {...rest}>
    <path
      fill="currentColor"
      d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z"
    />
  </StyledIcon>
)
Cancel.needsWork = true
Cancel.displayName = 'Cancel'
export default Cancel
